export default __webpack_public_path__ + "images/db-logos/nz.png";